export default function SectionContact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[700px] mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-2">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">投稿爆料</h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10">有料你就来！吃瓜群众的第一手线索，就是我们的下一条爆款</p>

        <div className="bg-background-50 rounded-xl p-6 md:p-10 border border-background-200/70">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6 mb-8">
            <div className="text-center p-4">
              <div className="w-12 h-12 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">邮件投稿</h3>
              <p className="text-xs text-foreground-500">tip@heiliaobaoliao.com</p>
            </div>
            <div className="text-center p-4">
              <div className="w-12 h-12 rounded-lg bg-accent-100 text-accent-600 flex items-center justify-center mx-auto mb-3">
                <i className="ri-wechat-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信投稿</h3>
              <p className="text-xs text-foreground-500">搜索：黑料爆料吃瓜</p>
            </div>
            <div className="text-center p-4">
              <div className="w-12 h-12 rounded-lg bg-secondary-100 text-secondary-600 flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-user-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">匿名爆料</h3>
              <p className="text-xs text-foreground-500">严格保护爆料人隐私</p>
            </div>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-lg p-4 md:p-6 max-w-[500px] mx-auto">
            <p className="text-sm text-foreground-700 mb-4">您的每一条线索我们都认真对待。高质量独家爆料一经采用，将获得丰厚奖励。爆料内容请尽量详实，附上相关证据更佳。</p>
            <div className="flex items-center justify-center gap-2 text-accent-600 text-sm font-semibold">
              <i className="ri-information-line"></i>
              <span>爆料人信息严格保密，绝不外泄</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}